import { createSelector } from 'reselect';

const selectHelpTopics = (state: any) => state.helpTopics;

export const selectHelpTopicsCurrentItem = createSelector([selectHelpTopics], (helpTopics) => helpTopics.current);

export const selectHelpTopicsListItems = createSelector([selectHelpTopics], (helpTopics) => helpTopics.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectHelpTopicsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectHelpTopicsCreatedItem = createSelector([selectHelpTopics], (helpTopics) => helpTopics.create);

export const selectHelpTopicsUpdatedItem = createSelector([selectHelpTopics], (helpTopics) => helpTopics.update);
export const selectHelpTopicsQueryItem = createSelector([selectHelpTopics], (helpTopics) => helpTopics.query);
export const selectHelpTopicsReadItem = createSelector([selectHelpTopics], (helpTopics) => helpTopics.read);

export const selectHelpTopicsDeletedItem = createSelector([selectHelpTopics], (helpTopics) => helpTopics.delete);

export const selectHelpTopicsSearchedItems = createSelector([selectHelpTopics], (helpTopics) => helpTopics.search);

export const selectHelpTopicsItemsCount = createSelector([selectHelpTopics], (helpTopics) => helpTopics.count);

export const selectHelpTopicsItemsFilter = createSelector([selectHelpTopics], (helpTopics) => helpTopics.filter);